import React, { createContext, useContext, useEffect, useState } from 'react';

const LanguageContext = createContext(); // Создаём контекст

const translations = {
    en: {
        newsletter: "Newsletter",
        description: "A game about robots, farms, and planets.",
        descriptionMore: "Silicone Heart is a cyber-farming sim where you fix robots, grow techno-plants, automate farm and rebuild life on a junkyard planet.",
        wishlist: "WISHLIST",
        presskit: "PRESSKIT",
        helloSlogan: "Glad to see you! Join our discord channel!",

        // --- Mailchimp Keys ---
        subscribeButton: "NEWSLETTER",
        subscribeModalTitle: "Subscribe to Our Newsletter and Receive Exclusive Robo-Helmets!",
        subscribeTitle: "Newsletter",
        subscribeSubtitle: "Short and useful updates: demos, release date, behind-the-scenes.",

        subscribeEmailLabel: "Email",
        subscribeNameLabel: "Name (optional)",
        subscribeEmailPlaceholder: "you@example.com",
        subscribeNamePlaceholder: "Name",

        subscribeSubmit: "Subscribe",
        subscribeClose: "Close",
        subscribeSending: "Sending...",

        subscribeSuccessTitle: "Done!",
        subscribeSuccessText: "Done! You’re on the list. If double opt-in is enabled, check your inbox to confirm.",

        subscribeHint: "By subscribing you agree to receive emails. Unsubscribe anytime.",
        subscribeNetworkError: "Network error (jsonp script failed).",

        ksLaunchingSoon: "Launching soon",
        ksDescription: "Silicone Heart is a cyber-farming sim where you fix robots, grow techno-plants, automate farm and rebuild life on a junkyard planet.",
        ksFirstCreated: "First created",
        ksBacked: "backed"
    },
    ru: {
        newsletter: "Подписка",
        description: "Игра про роботов, фермы и планеты.",
        descriptionMore: "Silicone Heart — это симулятор кибер-фермерства, в котором вы ремонтируете роботов, выращиваете техно-растения, автоматизируете ферму и восстанавливаете жизнь на планете-свалке.",
        wishlist: "В ЖЕЛАЕМОЕ",
        presskit: "МЕДИА-КИТ",
        helloSlogan: 'Рады тебя видеть! Подписывайся на наше сообщество!',

        // --- Mailchimp Keys ---
        subscribeButton: "ПОДПИСАТЬСЯ",
        subscribeModalTitle: "Подпишись на рассылку и получи уникальные робо-шлемы!",
        subscribeTitle: "Подписка",
        subscribeSubtitle: "Коротко и по делу: демки, дата релиза, закулисье.",

        subscribeEmailLabel: "Почта",
        subscribeNameLabel: "Имя (необязательно)",
        subscribeEmailPlaceholder: "you@example.com",
        subscribeNamePlaceholder: "Имя",

        subscribeSubmit: "Подписаться",
        subscribeClose: "Закрыть",
        subscribeSending: "Отправляем...",

        subscribeSuccessTitle: "Готово!",
        subscribeSuccessText: "Готово! Ты в списке. Если включён double opt-in — проверь почту и подтверди подписку.",

        subscribeHint: "Нажимая «Подписаться», ты соглашаешься получать новости по email. Отписка — в один клик.",
        subscribeNetworkError: "Ошибка сети (jsonp-скрипт не загрузился).",

        ksLaunchingSoon: "Скоро запуск",
        ksDescription: "Silicone Heart — это кибер-симулятор фермы, где вы чините роботов, выращиваете техно-растения и восстанавливаете жизнь на планете-свалке.",
        ksFirstCreated: "Первый проект",
        ksBacked: "поддержали"
    }
};

// Провайдер, чтобы распространять язык по всему приложению
export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState(() => {
        // Получаем язык из localStorage или используем 'en' по умолчанию
        return localStorage.getItem('language') || 'en';
    });

    const toggleLanguage = () => {
        const newLang = lang === 'en' ? 'ru' : 'en';
        setLang((prevLang) => (prevLang === 'en' ? 'ru' : 'en'));
        localStorage.setItem('language', newLang);
    };

    useEffect(() => {
        // Синхронизация при первом рендере
        localStorage.setItem('language', lang);
    }, [lang]);

    const t = (key) => translations[lang][key] || key;

    return (
        <LanguageContext.Provider value={{ lang, toggleLanguage, t }}>
            {children} {/* Дочерние компоненты будут иметь доступ к контексту */}
        </LanguageContext.Provider>
    );
};

// Хук для использования контекста
export const useLanguage = () => useContext(LanguageContext);


